export enum DropdownValues {
    YES = 1,
    NO = 2,
}